export default "__VITE_ASSET__C3ZJF8xC__"